export default __webpack_public_path__ + "static/media/28t.4ec7bdb8.jpg";